import AppFav from '../app-fav'
import CoreForm from '../core-form'
import CoreParseImg from '../core-parse-img'

import getCookies from '../../utils/getCookies.js'

export default
{
    components:
    {
        AppFav,
        CoreForm,
        CoreParseImg
    },

    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            isFormActive: false,
            href: ''
        }
    },

    created()
    {
        this.eventHub.$on('selection:closeForm', this.onToggleForm)
    },

    mounted()
    {
        const modalContent = []


        for(let i = 0; i < this.content.posts.length; i++)
        {
            if(this.content.posts[i].post_type === 'article' || this.content.posts[i].post_type === 'medias' || this.content.posts[i].post_type === 'agency')
            {
                modalContent.push(this.content.posts[i])
            }
        }

        this.eventHub.$emit('set:magmaContent', modalContent)

        this.href = getCookies('selections')

        // // clean cookies
        // this.href = this.href.split('')[0] === '+' ? this.href.substring(1) : this.href
        // this.href = this.href.replace(/^[\s\+\xA0]+|[\s\+\xA0]+$/g, '');

        this.$emit('page:ready')
    },

    destroyed()
    {
        document.body.classList.remove('u-overflow-h')
        this.eventHub.$off('selection:closeForm', this.onToggleForm)
    },

    methods:
    {
        onToggleForm()
        {
            this.isFormActive = !this.isFormActive
            this.eventHub.$emit('selection:openForm')

            if(this.isFormActive)
            {
                document.body.classList.add('u-overflow-h')
            }
            else
            {
                document.body.classList.remove('u-overflow-h')
            }
        },

        onDeleteSelection()
        {
            this.eventHub.$emit('selection:delete')
        },

        onFormSuccess()
        {
            this.$el.classList.add('is-form-success')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-selection/script.js